export default "__VITE_ASSET__DXfRdcCv__"